<template>
  <div class="shipment-tag-wrapper shipment-tag-correios">
    <div class="shipment-tag-header">
      <div class="shipment-tag-header-left">
        <img :src="$parent.tag.companyIcon" class="in-center" />
        <span class="website">{{ $parent.tag.website }}</span>
      </div>

      <div class="shipment-tag-header-center">
        <canvas class="datamatrix in-center"></canvas>
      </div>

      <div class="shipment-tag-header-right">
        <svg
          v-if="serviceIcon === ECONOMIC_ICON_ID"
          class="service-form"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 75.3922 75.158"
        >
          <path
            fill="#000000"
            d="M0,0c0,0,3.5121,53.1491,0,75.158c0,0,43.3154-2.5755,75.3922,0c0,0-2.5755-24.5844,0-75.158
            C75.3922,0,62.0464,2.3414,0,0z"
          />
        </svg>

        <svg
          v-if="serviceIcon === NORMAL_ICON_ID"
          class="service-form"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 85.7415 85.7415"
        >
          <circle fill="#000000" cx="42.8708" cy="42.8708" r="42.8708" />
        </svg>

        <svg
          v-if="serviceIcon === EXPRESS_ICON_ID"
          class="service-form"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 84.4713 93.6805"
          enable-background="new 0 0 84.4713 93.6805"
          xml:space="preserve"
        >
          <g>
            <path
              fill="#000000"
              d="M17.4659,93.6805h50.1747c0,0-0.6351-26.6751-25.0873-25.7225S17.4659,93.6805,17.4659,93.6805z"
            />
            <path
              fill="#000000"
              d="M0,64.4649c0,0,15.8781-22.5468,42.5532-22.5468s41.9181,22.5468,41.9181,22.5468V38.1073
                  c0,0-4.4459-38.1073-41.9181-38.1073S0,37.7898,0,37.7898V64.4649z"
            />
          </g>
        </svg>
      </div>
    </div>

    <div class="shipment-tag-info">
      <div class="field left">
        <span v-if="$parent.tag.invoice.number">NF: {{ $parent.tag.invoice.number }}</span>
        <span v-if="$parent.tag.authorizationCode">PLP: {{ $parent.tag.authorizationCode }}</span>
        <br v-else />
      </div>

      <div class="field center">
        <span v-if="validationTracking" class="spaced">
          Contrato:
          <strong>{{ $parent.tag.contract }}</strong>
        </span>

        <span>
          <strong>{{ serviceName }}</strong>
        </span>
      </div>

      <div class="field right">
        <span class="spaced">Volume: 1/1</span>

        <span v-if="$parent.tag.package.weight">
          Peso (g):
          <strong>{{ kilogramsToGrams($parent.tag.package.weight) }}</strong>
        </span>
      </div>
    </div>

    <div class="relative shipment-tag-barcode">
      <p class="mt-7 text-xs text-center">{{ $parent.tag.tracking }}</p>

      <canvas
        class="barcode"
        :data-value="$parent.tag.tracking"
        data-height="50"
        data-margin="0"
        data-displayvalue="false"
      ></canvas>

      <div class="additional-services" v-if="validationTracking">
        <div v-for="(item, index) in additionalServices" :key="index"  class="item-service">{{ item }}</div>
      </div>
    </div>

    <div class="signature">
      <div class="relative">
        <span class="text">Recebedor:</span>
        <span class="line" />
      </div>

      <div class="relative">
        <span class="text">Assinatura:</span>
        <span class="line" />

        <span class="text">Documento:</span>
        <span class="line" />
      </div>
    </div>

    <div class="shipment-tag-client shipment-tag-to">
      <div class="box">
        <span class="information">DESTINATÁRIO</span>
        <img src="/images/shipment/correios/logo-negativo.jpg" />
      </div>

      <div class="informations">
        <p class="line">{{ capitalize($parent.tag.to.name) }}</p>

        <p class="line">
          {{ capitalize($parent.tag.to.address) }}<template
            v-if="$parent.tag.to.locationNumber.length"
          >, {{ $parent.tag.to.locationNumber }}</template>
        </p>

        <p class="line">
          <template v-if="$parent.tag.to.complement.length">
            {{ capitalize($parent.tag.to.complement) }},
          </template>
          {{ capitalize($parent.tag.to.district) }}
        </p>

        <p class="line">
          <strong>{{ beautifyPostalCode($parent.tag.to.postalCode) }}</strong>
          {{ capitalize($parent.tag.to.city) }}
          <template v-if="$parent.tag.to.stateAbbr.length">/</template>
          {{ $parent.tag.to.stateAbbr }}
        </p>

        <p v-show="$parent.tag.to.note.length" class="line">
          Obs: {{ capitalize($parent.tag.to.note) }}
        </p>

        <div class="barcode-line">
          <canvas
            class="barcode postal"
            :data-value="$parent.tag.to.postalCode"
            data-height="35"
            data-margin="0"
            data-displayvalue="false"
          ></canvas>
        </div>
      </div>
    </div>

    <div class="shipment-tag-client shipment-tag-from">
      <div class="informations">
        <p class="line white-space-normal">
          <strong>Remetente:</strong>
          {{ capitalize($parent.tag.from.name) }}<span v-if="$parent.tag.from.phone">, Tel: {{ maskPhone($parent.tag.from.phone) }}</span>
        </p>

        <p class="line">
          {{ capitalize($parent.tag.from.address) }}<template
            v-if="$parent.tag.from.locationNumber.length"
          >, {{ $parent.tag.from.locationNumber }}</template>
        </p>

        <p class="line">
          <template v-if="$parent.tag.from.complement.length">
            {{ capitalize($parent.tag.from.complement) }},
          </template>
          {{ capitalize($parent.tag.from.district) }}
        </p>

        <p class="line">
          <strong>{{ beautifyPostalCode($parent.tag.from.postalCode) }}</strong>
          {{ capitalize($parent.tag.from.city) }}
          <template v-if="$parent.tag.from.stateAbbr.length">/</template>
          {{ $parent.tag.from.stateAbbr }}
        </p>
      </div>
    </div>

    <div class="shipment-tag-melhor-ponto-qr-code">
      <canvas class="melhor-ponto-code"></canvas>
    </div>
  </div>
</template>

<script>
import '../../../extends/string.js';
import '../../../libs/datamatrix.js';
import { kilogramsToGrams, maskPhone } from 'commons/js/formatters/Mask';
import { beautifyPostalCode } from 'commons/js/formatters/PostalCode';
import { capitalize } from 'commons/js/formatters/String';
import ShippingDefinitions from 'commons/js/ShippingDefinitions'
import MelhorPontoQrCode from 'commons/js/mixins/melhorPontoQrCode';
import { getPostalCodeVerifyingDigit } from 'commons/js/utils/getPostalCodeVerifyingDigit';
import bwipjs from 'bwip-js';

const ECONOMIC_ICON_ID = 1;
const NORMAL_ICON_ID = 2;
const EXPRESS_ICON_ID = 3;
const DATAMATRIX_SIZE = 20; // in millimeters = 80px

export default {
  mixins: [MelhorPontoQrCode],

  data() {
    return {
      shippingCompanyIcon: '',
      serviceIcon: NORMAL_ICON_ID,
      serviceName: 'PAC',
      additionalServices: [],
      NORMAL_ICON_ID,
      EXPRESS_ICON_ID,
      ECONOMIC_ICON_ID,
    }
  },

  computed: {
    validationTracking() {
      return !!(this.$parent.tag.authorizationCode) || !!(this.$parent.tag.tracking)
    },
  },

  created() {
    switch (this.$parent.tag.serviceIcon) {
      case 'normal':
        this.serviceIcon = NORMAL_ICON_ID;
        break;
      case 'express':
        this.serviceIcon = EXPRESS_ICON_ID;
        break;
      case 'economic':
        this.serviceIcon = ECONOMIC_ICON_ID;
        break;
    }

    this.serviceName = this.$parent.serviceName;

    if (
      this.$parent.tag.serviceId == ShippingDefinitions.CORREIOS_PAC_GRANDES_FORMATOS_ID
      || this.$parent.tag.serviceId == ShippingDefinitions.CORREIOS_SEDEX_GRANDES_FORMATOS_ID
    ) {
      this.additionalServices.push('GF');
    }

    if (this.$parent.tag.receipt) {
      // AVISO DE RECEBIMENTO
      this.additionalServices.push('AR');
    }

    if (this.$parent.tag.ownHand) {
      // MAO PROPRIA
      this.additionalServices.push('MP');
    }

    // REGISTRO NACIONAL
    // this.additionalServices.push('RR');

    while (this.additionalServices.length < 4) {
      this.additionalServices.push('');
    }

    // GF - GRANDES FORMATOS (PAC / SEDEX GRANDES FORMATOS)

    // OF - OUTROS FORMATOS (ROLO / PRISMA)

    // DD - DEVOLUÇÃO DE DOCUMENTOS
  },

  methods: {
    makeDataMatrix() {
      let data = '';
      data += String(this.$parent.tag.to.postalCode).padStart(8, '0'); // CEP destino (8)
      data += String('').padStart(5, '0'); // Complemento do CEP (5)
      data += String(this.$parent.tag.from.postalCode).padStart(8, '0'); // CEP origem (8)
      data += String('').padStart(5, '0'); // Complemento do CEP (5)
      data += getPostalCodeVerifyingDigit(this.$parent.tag.to.postalCode); // Validador do CEP destino (1)
      data += '51'; // IDV (2) 51 = Encomenda, 81 = Malotes
      data += this.$parent.tag.tracking; // Código de Rastreamento (13)
      // Serviços Adicionais (AR, MP, DD, VD) 8
      data += this.$parent.tag.receipt ? 'AR' : '00'; // AR: Aviso de Recebimento (2)
      data += this.$parent.tag.ownHand ? 'MP' : '00'; // MP: Mão Própria (2)
      data += '00'; // DD: Devolução de Documentos (2)
      data += 'VD'; // VD: Valor Declarado (2) (Se não houver, será o seguro padrão)
      data += this.$parent.tag.authorizationCode ? String(this.$parent.tag.authorizationCode).padStart(10, '0') : ''; // Cartão de Postagem (10)
      data += String(this.$parent.tag.serviceCode).padStart(5, '0'); // Código do Serviço (5)
      data += '00'; // Informação de Agrupamento (2)
      data += String(this.$parent.tag.to.locationNumber).toUpperCase().substring(0, 5).padEnd(5); // Número do Logradouro (5)
      data += (this.$parent.tag.to.complement ? String(this.$parent.tag.to.complement).toUpperCase().substring(0, 20) : '').padEnd(20); // Complemento do Logradouro (20)
      data += (this.$parent.tag.insuranceValue ? String(this.$parent.tag.insuranceValue) : '').padStart(5, '0'); // Valor Declarado (5)
      data += (this.$parent.tag.to.phone ? String(this.$parent.tag.to.phone) : '').padStart(12, '0'); // DDD + Telefone Destinatário (12)
      data += '-00.000000'; // Latitude (10)
      data += '-00.000000'; // Longitude (10)
      data += '|'; // Pipe “|” (1)
      data += 'https://melhorenvio.com.br'; // Reserva para cliente (30)
      return data;
    },
    kilogramsToGrams,
    maskPhone,
    beautifyPostalCode,
    capitalize,
  },

  mounted() {
    BarCode('.barcode').init();

    const element = this.$el.querySelector('.datamatrix');

    bwipjs.toCanvas(element, {
      bcid: 'datamatrix',
      width: DATAMATRIX_SIZE,
      height: DATAMATRIX_SIZE,
      text: this.makeDataMatrix(),
      textxalign: 'center',
    });
  },
}
</script>

<style lang="stylus" scoped>
.shipment-tag-correios
  strong
    font-weight bold
  .line
    margin-bottom 2px !important
    padding 0 !important
  .white-space-normal
    white-space normal !important
  .service-form
    max-height 70%
    position absolute
    top 5px
    right 0
  .item-service
    font-size 11pt
    height 14px
  .website
    position absolute
    bottom 5px
    left 50%
    transform translateX(-50%)
    font-weight bold
    font-size 8pt
  .relative
    position relative
  .signature
    margin 0 10px
    padding 3px 0
    .relative
      display flex
      align-items center
      &:first-of-type
        margin-bottom 3px
      .text
        flex 0 0 auto
        margin-right 4px
        font-size 7.5pt
        line-height 11.5px
      .line
        flex 1 1 auto
        height 11px
        min-height 0
        border-bottom 1px solid #000
  .additional-services
    position absolute
    bottom 0
    font-weight bold
    right 10px
  .shipment-tag-header
    padding 5px 10px 0
    height 85px
    .in-center
      position absolute
      top 50%
      left 50%
      transform translate(-50%, -50%)
    img
      width 90%
    .code
      transform translate(-50%, -50%) scale(0.66)
      overflow hidden !important
    .shipment-tag-header-left
    .shipment-tag-header-center
    .shipment-tag-header-right
      position relative
      width 33.33%
      height 100%
      display inline-block
    .shipment-tag-header-left
      float left
    .shipment-tag-header-center
      margin 0 auto
    .shipment-tag-header-right
      float right
  .shipment-tag-info
    >>> .field
      width 33.33%
      text-align center
      line-height 1
      &.right
        float right
      span
      strong
        font-size 6.8pt
      span
        display block
    >>> .left
    >>> .center
      float left
  .shipment-tag-client
    margin-bottom 3px
    padding 0 5px
    position relative
    h2
      margin 5px 0
      font-weight bold
    p
      margin 0
      white-space nowrap
    &.shipment-tag-to
      border-top 2px solid #000
      border-bottom 2px solid #000
      .barcode
        margin-top 2px
        margin-bottom 2px
      .box
        display flex
        align-items flex-start
        justify-content space-between
        .information
          margin-left -5px
          background rgb(22, 19, 19)
          color #fff
          font-weight bold
          padding 3px 5px
          font-size 8.3pt
          line-height 13px
          -webkit-print-color-adjust exact
        img
          height 14px
          margin 3px 5px 0 0
        &:after
          content none
    &.shipment-tag-to
    &.shipment-tag-from
      .informations
        margin-top 2px
        p.line
        strong
        span
          min-height 0
          margin-bottom 0
          font-size 10px
          line-height 1
          text-transform none
        .barcode-line
          margin 4px 24px
  .shipment-tag-melhor-ponto-qr-code
    padding 3px
    border-top 2px solid #000
    text-align center
  .shipment-tag-barcode
    .barcode
      max-width 80%
  .spaced
    margin-bottom 4px
  .spaced-t
    margin-top 4px
@media print
  .shipment-tag-correios
    .shipment-tag-header
      height 100px !important
      img
        width 78%
      .code
        transform translate(-50%, -50%) scale(0.7) !important
</style>
